export default __webpack_public_path__ + "static/media/p04 p01.e8511d38.jpg";